import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { filterExists } from '~/utils'

import { useIsCoreMember } from '../useIsCoreMember'

import { useAllBrandAccountsQueryKey } from './useAllBrandAccountsQueryKey'

const document = graphql(`
  query UseAllBrandAccountsQuery_Main {
    brandAccounts {
      id
      name
      isSurveyEditor
    }
  }
`)

// 初期表示時に何度かリクエストが飛んでしまうのでそれを回避したい
const fixedStaleTime = 30 * 1000 // 30 seconds
export const useAllBrandAccountsQuery = () => {
  const graphQLRequest = useGraphQLRequest()
  const isCoreMember = useIsCoreMember()
  const queryKey = useAllBrandAccountsQueryKey()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return R.pipe(
        result.brandAccounts,
        filterExists,
        R.map((brandAccount) => ({
          ...brandAccount,
          isSurveyEditor: brandAccount.isSurveyEditor === true || isCoreMember,
        })),
      )
    },
    queryKey,
    enabled: isCoreMember,
    staleTime: fixedStaleTime,
  })
}

export type AllBrandAccounts = NonNullable<
  QueryResultOf<typeof useAllBrandAccountsQuery>
>
export type AllBrandAccount = AllBrandAccounts[number]
